import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { usePunditUserContext } from "@circle-react/contexts";

export const CircleBotFooterMessage = () => {
  const { currentCommunitySettings, isLoading: isLoadingPunditUserContext } =
    usePunditUserContext();

  const isCopilotActionsEnabled =
    !isLoadingPunditUserContext &&
    currentCommunitySettings?.help_widget_copilot_actions_enabled;

  return (
    <div className="flex justify-center rounded-lg px-4 pb-4">
      <Typography.BodyXs color="text-[#A5A9AD]">
        {isCopilotActionsEnabled
          ? t("help_widget.conversation_page.copilot_footer_message")
          : t("help_widget.conversation_page.footer_message")}
        <TippyV2
          arrow={false}
          theme="help-widget-tooltip"
          content={
            isCopilotActionsEnabled
              ? t(
                  "help_widget.conversation_page.copilot_footer_message_tooltip",
                )
              : t("help_widget.conversation_page.footer_message_tooltip")
          }
        >
          <Icon type="info" size={14} useWithFillCurrentColor />
        </TippyV2>
      </Typography.BodyXs>
    </div>
  );
};
